module.exports = __webpack_public_path__ + "static/img/goods-800.a49b474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/pop/goods-800.png
// module id = m2AG
// module chunks = 2